import { createRequestTypes } from 'common/websocket-redux';

export const GET_GROUP = createRequestTypes('hr-admin/GET_GROUP');
